import type { PracticalProject } from "../../data";

export const serverDomainMigration: PracticalProject = {
  id: "server-domain-migration",
  num: 7,
  title: "実践プロジェクト⑦ 株式会社モノクラフト ドメイン・サーバー移行プロジェクト",
  description:
    "老朽化した単一 VPS で稼働する EC サイトを、クラウドへ移行しつつドメインをカットオーバーする。DNS 切替・データ移行・ロールバック基準など、正解が 1 つに定まらない移行判断に取り組む",
  duration: "5 日〜2 週間",
  techStack: [],
  difficulty: "beginner",
  phase: "Phase 3 後半",
  learningOutcomes: [
    "現行インフラの制約条件を正確に読み取り、移行方針の大枠を組み立てられるようになる",
    "DNS・データ移行・カットオーバーに関する意思決定を、リスクとトレードオフの両面から検討できるようになる",
    "切替後の検証観点と旧環境の廃止判断を、根拠を示しながら整理できるようになる",
  ],
  chapters: [
    { num: 1, title: "現状分析とヒアリング" },
    { num: 2, title: "移行計画と実行判断" },
    { num: 3, title: "完了確認と提出" },
  ],
};
